<template>
<div class="setup-section">
  <div class="setup">
    <h3>Настройки</h3>
    <div class="setup__list">
      <p class="setup__item">
        <span>Подсказка: ({{ params.startTime }} сек.)</span>
        <range-slider
          class="setup__range"
          min="0"
          max="5"
          step="1"
          v-model="params.startTime">
        </range-slider>
      </p>
      <p class="setup__item" v-show="!params.noTimer">
        <span>Таймер: ({{ params.timer }} сек.)</span>
        <range-slider
          class="setup__range"
          min="15"
          max="90"
          step="5"
          v-model="params.timer">
        </range-slider>
      </p>
      <p class="setup__item">
        <span>Карточки: ({{ params.cards }})</span>
        <range-slider
          class="setup__range"
          min="8"
          max="16"
          step="2"
          v-model="params.cards">
        </range-slider>
      </p>

      <p class="setup__item setup__item--checkbox">
        <input type="checkbox" id="no-timer" v-model="params.noTimer" @change="params.timer = params.noTimer ? null : 30">
        <label for="no-timer">Без таймера</label>
      </p>

      <p class="setup__item setup__item--checkbox">
        <input type="checkbox" id="show-reactions" v-model="params.reactions">
        <label for="show-reactions">Анимация</label>
      </p>

      <p class="setup__item setup__item--checkbox">
        <input type="checkbox" id="show-sounds" v-model="params.sounds">
        <label for="show-sounds">Звуки</label>
      </p>
    </div>
    <button 
      class="uk-button uk-button-primary setup__button" 
      @click="$emit('start', params)"
      v-if="!is_homework"
    >
      СТАРТ!
    </button>
  </div>
  <div class="setup__description" v-if="!is_homework">
    <h3>Инструкция</h3>
    <div class="setup__text" v-html="trainer.instruction"></div>
    <div class="setup__image">
      <img v-if="trainer.inner_image" :src="trainer.inner_image.path" alt="">
    </div>
  </div>
</div>
</template>

<script>
import RangeSlider from 'vue-range-slider'

export default {
  props: ['trainer', 'is_homework', 'homework_params'],
  components: { RangeSlider },
  data() {
    return {
      params: {
        startTime: 3,
        timer: 30,
        cards: 8,
        reactions: false,
        sounds: false,
        noTimer: false
      }
    }
  },
  created() {
    if (this.homework_params) {
      this.params = this.homework_params
    }
  },
  mounted() {    
    this.$emit('params_changed', this.params)
  },
  watch: {
    params: {
      handler: function (params) { 
        this.$emit('params_changed', params)
      },
      deep: true
    }
  }
}
</script>

